import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { type Campaign } from '@feathr/blackbox';
import { Button, TLDR } from '@feathr/components';
import { useLocalUrl, useStore } from '@feathr/extender/state';

import CampaignTypeChip from '../../CampaignTypeChip';

import * as styles from './CampaignTLDR.css';

interface IProps {
  readonly campaign?: Campaign;
}

function CampaignTLDR({ campaign }: IProps): JSX.Element {
  const { t } = useTranslation();
  const localUrl = useLocalUrl();
  const { Creatives } = useStore();
  const creatives = campaign?.isCreativesCampaign
    ? Creatives.list({ filters: { _parent: campaign.id }, pagination: { page_size: 1 } })
    : undefined;

  if (campaign === undefined || campaign.isPending || creatives?.isPending) {
    return <TLDR isLoading={true} />;
  }

  const type = campaign.get('_cls');
  const chip = <CampaignTypeChip className={styles.chip} cls={type} />;

  return (
    <TLDR
      action={
        <Button href={localUrl(campaign.getItemUrl())} target={'_blank'}>
          {t('View report')}
        </Button>
      }
      description={chip}
      isLoading={false}
      title={campaign.name}
    />
  );
}

export default observer(CampaignTLDR);
